import { Locale } from '../helpers/LangHelper';
import BaseModel from './BaseModel';
import { GetContentOptions } from '@builder.io/sdk';

class BusinessIndustriesModel extends BaseModel {
    constructor() {
        super({ modelName: 'business-industries' });
    }

    getAllIndustries = async ({ locale, includeUnpublished = false, includeDraft = false }: { locale?: Locale; includeUnpublished?: boolean; includeDraft?: boolean }) => {
        const config: GetContentOptions = {
            options: { includeUnpublished, noTargeting: true },
            userAttributes: {
                locale,
            },
            query: {},
        };

        if (locale) {
            config.query.query = {
                $elemMatch: {
                    property: {
                        $eq: 'locale',
                    },
                    value: locale,
                },
            };
        }

        const messages = await this.builder.getAll(this.modelName, config);

        return messages;
    };

    getIndustry = async (id: string, includeUnpublished = false) => {
        return this.find({ params: { modelId: id }, includeUnpublished });
    };
}

export default new BusinessIndustriesModel();
